export function checkForPatientGroup (group) {
  return group.patientName || group.patientId
}
